export default "__VITE_ASSET__BXqmvekx__"